import { matchSorter, MatchSorterOptions } from 'match-sorter';

export function getMatchingOptionsInSortedOrder<OptionType>(
  options: OptionType[],
  matchString?: string,
  matchSorterOptions?: MatchSorterOptions<OptionType>,
) {
  if (!matchString) {
    return options;
  }
  return matchSorter<OptionType>(options, matchString, matchSorterOptions);
}
